"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
  _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
  _react = _interopRequireWildcard(require("react")),
  _RenderField = _interopRequireDefault(require("./RenderField")),
  divideFieldsIntoPages = function divideFieldsIntoPages(a, b) {
    for (var c, d = b.map(function () {
        return [];
      }), e = 0; e < a.length; e++) c = d[a[e].pageNumber], d[a[e].pageNumber - 1] && ("page" === a[e].type ? d[a[e].pageNumber - 2].push(a[e]) : d[a[e].pageNumber - 1].push(a[e]));
    return d;
  },
  getMaxFieldId = function getMaxFieldId(a) {
    for (var b = 0, c = 0; c < a.length; c++) parseInt(a[c].id) > b && (b = parseInt(a[c].id));
    return b + 1;
  },
  fieldTypes = ["checkbox", "email", "hidden", "html", "number", "phone", "radio", "select", "multiselect", "text", "textarea", "website", "page", "date", "fileupload", "consent", "password", "section", "custom"],
  honeyPotLables = ["Name", "Email", "Phone", "Comments"],
  honeypotLabel = honeyPotLables[Math.floor(Math.random() * Math.floor(4))],
  _default = function _default(a) {
    var b = a.fields,
      c = a.formValues,
      d = a.updateForm,
      e = a.submitFailed,
      f = a.submitSuccess,
      g = a.touched,
      h = a.setTouched,
      i = a.pagination,
      j = a.activePage,
      k = a.prevStep,
      l = a.nextStep,
      m = a.isNextDisabled,
      n = a.checkConditionalLogic,
      o = a.saveStateToHtmlField,
      p = a.enableHoneypot,
      q = a.styledComponents,
      r = a.customComponents,
      s = a.unsetError,
      t = a.errors,
      u = a.dropzoneText,
      v = a.pageClicked,
      w = a.formatChars,
      x = i ? divideFieldsIntoPages(b, i.pages) : void 0,
      y = getMaxFieldId(b),
      z = (0, _react.useState)(""),
      A = (0, _slicedToArray2["default"])(z, 2),
      B = A[0],
      C = A[1],
      D = (0, _react.useRef)();
    (0, _react.useEffect)(function () {
      D.current = j;
    });
    var E = D.current;
    return _react["default"].createElement("div", {
      className: "form-fields".concat(i && 1 < i.pages.length ? " hasPages ".concat(v ? "" : " noPageClicked") : "")
    }, i && 1 < i.pages.length ? i.pages.map(function (a, b) {
      return _react["default"].createElement("div", {
        className: "page".concat(j === b + 1 ? " active" : "").concat(E && b === E && j !== b + 1 && E !== j ? " prevStep" : ""),
        key: "page-".concat(b)
      }, a && _react["default"].createElement("div", {
        className: "gf_step"
      }, _react["default"].createElement("span", null, a)), x[b].map(function (a) {
        return fieldTypes.includes(a.type) && _react["default"].createElement(_RenderField["default"], {
          key: "".concat(a.formId, "-").concat(a.id),
          field: a,
          formValues: c,
          submitFailed: e,
          setTouched: h,
          submitSuccess: f,
          updateForm: d,
          touched: g,
          pages: i.pages.length,
          prevStep: k,
          nextStep: l,
          isNextDisabled: m,
          checkConditionalLogic: n,
          saveStateToHtmlField: o,
          styledComponents: q,
          customComponents: r,
          error: !!(t && t[a.id]) && t[a.id],
          unsetError: s,
          dropzoneText: u,
          formatChars: w
        });
      }));
    }) : b.map(function (a) {
      return fieldTypes.includes(a.type) && _react["default"].createElement(_RenderField["default"], {
        key: "".concat(a.formId, "-").concat(a.id),
        field: a,
        formValues: c,
        submitFailed: e,
        setTouched: h,
        submitSuccess: f,
        updateForm: d,
        touched: g,
        checkConditionalLogic: n,
        styledComponents: q,
        error: !!(t && t[a.id]) && t[a.id],
        unsetError: s,
        dropzoneText: u,
        customComponents: r,
        formatChars: w
      });
    }), p && _react["default"].createElement("div", {
      className: "form-field gform_validation_container"
    }, _react["default"].createElement("label", {
      htmlFor: "input_".concat(y),
      className: "gf-label "
    }, honeypotLabel), _react["default"].createElement("input", {
      type: "text",
      name: "input_".concat(y),
      id: "input_".concat(y),
      value: B,
      onChange: function onChange(a) {
        return C(a.target.value);
      },
      autoComplete: "off"
    })));
  };
exports["default"] = _default;